import React from 'react';
import { TwitchEmbed } from '../components/complex/TwitchEmbed';
import { RAW, RADII } from '../theme';

/**
 * TwitchPiPContent — the body of the Twitch live-stream PiP, propless.
 *
 * Phase 2: folded onto the unified window engine. WindowHost mounts this
 * component (only while the `twitchPiP` window is open) inside the shared
 * ToolWindow chrome, so it no longer owns its own ToolWindow / isOpen /
 * onClose props — the engine handles open/close + the frozen `twitch-pip`
 * geometry key. Player-free (just a Twitch embed).
 */

const embedContainerStyle: React.CSSProperties = {
  width: '100%',
  height: '100%',
  background: RAW.black,
  borderRadius: RADII.lg,
  overflow: 'hidden',
};

export const TwitchPiPContent: React.FC = () => (
  <div style={embedContainerStyle}>
    <TwitchEmbed
      channel="djmsqrvve"
      width="100%"
      height="100%"
    />
  </div>
);
